export default __webpack_public_path__ + "static/media/FC-large.d2cd5333.png";